// VERY IMPORTANT!
// Make sure you use descriptive names in the strings, otherwise there will be name clashes.
// In other words, we cannot re-use a name inside a string inside another redux component

export const SET_AUDIO_FILE_FETCH_DATA = "SET_AUDIO_FILE_FETCH_DATA",
  AUDIO_LOADING = "AUDIO_LOADING",
  API_V1_GET_AUDIO_FILE_INFO_REQUEST = "API_V1_GET_AUDIO_FILE_INFO_REQUEST",
  API_V1_GET_AUDIO_FILE_INFO_SUCCESS = "API_V1_GET_AUDIO_FILE_INFO_SUCCESS",
  API_V1_GET_AUDIO_FILE_INFO_FAILURE = "API_V1_GET_AUDIO_FILE_INFO_FAILURE",
  API_V1_AUDIO_FILE_REVIEW_REQUEST = "API_V1_AUDIO_FILE_REVIEW_REQUEST",
  API_V1_AUDIO_FILE_REVIEW_SUCCESS = "API_V1_AUDIO_FILE_REVIEW_SUCCESS",
  API_V1_AUDIO_FILE_REVIEW_FAILURE = "API_V1_AUDIO_FILE_REVIEW_FAILURE";
